import { render, staticRenderFns } from "./CadastroCongresso.vue?vue&type=template&id=8f43ca2e&"
import script from "./CadastroCongresso.vue?vue&type=script&lang=js&"
export * from "./CadastroCongresso.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCongresso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports